import React from "react";
import Layout from "../common/Layout";

const About: React.FC = () => {
  return <Layout title="Ohjeet ja tuki">
  </Layout>
};

export default About;
